export default __webpack_public_path__ + "static/logo-01-04a6397fc500793904a556892d9bebe0.svg";